'use strict';

function CompanyDetailCtrl(
  $scope,
  translations,
  company,
  info,
  $stateParams,
  $translate
) {
  $scope.company = company;
  $scope.info = info;

  $scope.availableLanguages = [
    { value: "en", label: "English" },
    { value: "se", label: "Svenska" }
  ];

  $scope.publicationTypesToLower = [];
  angular.forEach($scope.types, function(v){
    $scope.publicationTypesToLower.push(v.toLowerCase());
    if (!$scope.info.features.publicationNr.hasOwnProperty(v.toLowerCase())) {
      $scope.info.features.publicationNr[v.toLowerCase()] = 0;
    }
  });

  $scope.switchLanguage = function(langKey) {
    $translate.use(langKey);
  };
}

CompanyDetailCtrl.resolve = {
  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService) {
    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'company.information'
    ]);
  }]
};

module.exports = CompanyDetailCtrl;

angular.module('dokiv')
  .controller('CompanyDetailCtrl', [
  '$scope',
  'translations',
  'company',
  'info',
  '$stateParams',
  '$translate',
  CompanyDetailCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/account/CompanyDetailCtrl.js
// module id = 317
// module chunks = 0